import type { ReactNode } from 'react';
import { Button } from '../ui';

/**
 * C8 announcement bar: a double hairline box (outer 2px bright pink, 4px
 * white gap, inner 1px pink), heading left, outline button right. Links to a
 * page (the Perfect Storm webinar page or events), never a popup player.
 *
 *   <AnswerBar title="Free parent webinar: The Perfect Storm" button={{ label: 'See the webinar', to: '/the-perfect-storm/' }} />
 */
export interface AnnouncementBarProps {
  title: ReactNode;
  text?: ReactNode;
  button: { label: string; to?: string; href?: string };
  headingId?: string;
  className?: string;
}

export default function AnnouncementBar({ title, text, button, headingId, className = '' }: AnnouncementBarProps) {
  return (
    <div className={`ve-container ve-container--wide ${className}`.trim()}>
      <div className="ve-home-announce" role="region" aria-labelledby={headingId}>
        <div className="ve-home-announce-inner">
          <div className="ve-home-announce-copy">
            <h2 id={headingId} className="ve-home-announce-title">
              {title}
            </h2>
            {text && <p className="ve-home-announce-text">{text}</p>}
          </div>
          <Button variant="outline" to={button.to} href={button.href}>
            {button.label}
          </Button>
        </div>
      </div>
    </div>
  );
}
